/**
 * Geçmiş cevaplar (buyer.reply_examples, v0.1.38) for the panel: GET /reply-examples lists
 * the shop's own past replies that mail-history paired with the customer's question (newest
 * first), POST /reply-examples/{id}/retire takes one out of the Temsilci's examples and
 * POST /reply-examples/{id}/restore brings it back. Texts are already scrubbed of addresses
 * and phone numbers; the list is company-facing shop correspondence, no Etsy buyer data.
 */
import { z } from 'zod';
const count = z.number().int().nonnegative();
export const REPLY_EXAMPLE_STATUSES = ['active', 'retired'];
export const REPLY_EXAMPLE_SOURCES = ['gmail_sent', 'claude_export', 'manual'];
export const replyExampleSchema = z.strictObject({
    id: z.string(),
    sentAt: z.number(),
    subject: z.string().nullable(),
    /** The customer's question as recovered (clipped); null when neither the inbound mail nor a quote was found. */
    question: z.string().nullable(),
    answer: z.string(),
    /** True when the inbound mail itself was found (not only the quoted part). */
    paired: z.boolean(),
    productId: z.string().nullable(),
    productTitle: z.string().nullable(),
    productSku: z.string().nullable(),
    vehicleHint: z.string().nullable(),
    language: z.string().nullable(),
    source: z.enum(REPLY_EXAMPLE_SOURCES),
    status: z.enum(REPLY_EXAMPLE_STATUSES),
});
export const replyExamplesViewSchema = z.strictObject({
    asOf: z.number(),
    counts: z.strictObject({
        total: count,
        active: count,
        retired: count,
        paired: count,
        withProduct: count,
    }),
    oldestSentAt: z.number().nullable(),
    newestSentAt: z.number().nullable(),
    /** Newest first, at most 200; the panel filters by text. */
    examples: z.array(replyExampleSchema),
});
export const replyExampleDecisionResponseSchema = z.strictObject({
    id: z.string(),
    status: z.enum(REPLY_EXAMPLE_STATUSES),
});
//# sourceMappingURL=reply-examples.js.map